import * as React from 'react';
import MessagesFileButtons from './MessagesFileButtons';
const MessagesView = ({ body, fileMeta, timestamp, title, }) => {
    return (React.createElement("div", null,
        title !== undefined || timestamp !== undefined ? (React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
            React.createElement(MessagesFileButtons, { fileMeta: fileMeta }),
            React.createElement("h4", null, title),
            React.createElement("h5", null, timestamp?.toLocaleString()))) : undefined,
        React.createElement("div", { dangerouslySetInnerHTML: { __html: body } })));
};
export default MessagesView;
